const { DefaultEventTypes } = require('./default');

const OAUTH_TAG = 'oauth';

const OauthEvents = {
  SUCCESS: `${OAUTH_TAG}.${DefaultEventTypes.SUCCESS}`,
  FAILED: `${OAUTH_TAG}.${DefaultEventTypes.FAILED}`,
};

module.exports = { OauthEvents, OAUTH_TAG };
